/**
 * ToolTip Utils
 *
 * @since 2019-04-24
 * @author mk.ko
 *
 * 2019-04-24 - dataTable 용 tooltip util frontend 에도 포팅
 */

export function parsePosition (pos) {
  const parts = pos.split(' ')
  return {vertical: parts[0], horizontal: parts[1]}
}

export function position (e) {
  let posx, posy

  if (e.touches && e.touches[0]) {
    e = e.touches[0]
  } else if (e.changedTouches && e.changedTouches[0]) {
    e = e.changedTouches[0]
  }

  if (e.clientX || e.clientY) {
    posx = e.clientX
    posy = e.clientY
  } else if (e.pageX || e.pageY) {
    posx = e.pageX - document.body.scrollLeft - document.documentElement.scrollLeft
    posy = e.pageY - document.body.scrollTop - document.documentElement.scrollTop
  } else {
    const offset = targetElement(e).getBoundingClientRect()
    posx = ((offset.right - offset.left) / 2) + offset.left
    posy = ((offset.bottom - offset.top) / 2) + offset.top
  }

  return {
    top: posy,
    left: posx
  }
}

export function targetElement (e) {
  let target

  if (e.target) {
    target = e.target
  } else if (e.srcElement) {
    target = e.srcElement
  }

  // defeat Safari bug
  if (target.nodeType === 3) {
    target = target.parentNode
  }

  return target
}

export function getTargetPosition (el) {
  return {
    top: 0,
    center: el.offsetHeight / 2,
    bottom: el.offsetHeight,
    left: 0,
    middle: el.offsetWidth / 2,
    right: el.offsetWidth
  }
}

export function setToolTipPosition ({el, animate, anchorEl, anchorOrigin, selfOrigin, maxWidth, maxHeight, event, anchorClick, touchPosition, offset, touchOffset, cover}) {
  let anchor
  el.style.maxHeight = maxHeight || '65vh'
  el.style.maxWidth = '100vw'

  if (event && (!anchorClick || touchPosition)) {
    const {top, left} = position(event)
    anchor = {top, left, width: 1, height: 1, right: left + 1, center: top, middle: left, bottom: top + 1}
  } else {
    if (touchOffset) {
      const
        {top: anchorTop, left: anchorLeft} = anchorEl.getBoundingClientRect(),
        top = anchorTop + touchOffset.top,
        left = anchorLeft + touchOffset.left
      anchor = {top, left, width: 1, height: 1, right: left + 1, center: top, middle: left, bottom: top + 1}
    } else {
      anchor = getAnchorPosition(anchorEl, offset)
    }
  }

  const target = getTargetPosition(el)
  let targetPosition = {
    top: anchor[anchorOrigin.vertical] - target[selfOrigin.vertical],
    left: anchor[anchorOrigin.horizontal] - target[selfOrigin.horizontal]
  }

  targetPosition = repositionIfNeeded(anchor, target, selfOrigin, anchorOrigin, targetPosition, cover)

  el.style.top = Math.max(0, targetPosition.top) + 'px'
  el.style.left = Math.max(0, targetPosition.left) + 'px'
  if (targetPosition.maxHeight) {
    el.style.maxHeight = `${targetPosition.maxHeight}px`
  }
  if (targetPosition.maxWidth) {
    el.style.maxWidth = `${targetPosition.maxWidth}px`
  }

  if (animate) {
    const directions = targetPosition.top < anchor.top ? ['up', 'down'] : ['down', 'up']
    el.classList.add(`animate-popup-${directions[0]}`)
    el.classList.remove(`animate-popup-${directions[1]}`)
  }
}

let size

export function getScrollbarWidth () {
  if (size !== undefined) {
    return size
  }

  const
    inner = document.createElement('p'),
    outer = document.createElement('div')

  css(inner, {
    width: '100%',
    height: '200px'
  })
  css(outer, {
    position: 'absolute',
    top: '0px',
    left: '0px',
    visibility: 'hidden',
    width: '200px',
    height: '150px',
    overflow: 'hidden'
  })

  outer.appendChild(inner)

  document.body.appendChild(outer)

  const w1 = inner.offsetWidth
  outer.style.overflow = 'scroll'
  let w2 = inner.offsetWidth

  if (w1 === w2) {
    w2 = outer.clientWidth
  }

  outer.remove()
  size = w1 - w2

  return size
}

export function repositionIfNeeded (anchor, target, selfOrigin, anchorOrigin, targetPosition, cover) {
  const margin = getScrollbarWidth()
  let {innerHeight, innerWidth} = window
  // don't go bellow scrollbars
  innerHeight -= margin
  innerWidth -= margin

  if (targetPosition.top < 0 || targetPosition.top + target.bottom > innerHeight) {
    if (selfOrigin.vertical === 'center') {
      targetPosition.top = anchor[selfOrigin.vertical] > innerHeight / 2 ? innerHeight - target.bottom : 0
      targetPosition.maxHeight = Math.min(target.bottom, innerHeight)
    } else if (anchor[selfOrigin.vertical] > innerHeight / 2) {
      const anchorY = Math.min(innerHeight, anchorOrigin.vertical === 'center' ? anchor.center : (anchorOrigin.vertical === selfOrigin.vertical ? anchor.bottom : anchor.top))
      targetPosition.maxHeight = Math.min(target.bottom, anchorY)
      targetPosition.top = Math.max(0, anchorY - targetPosition.maxHeight)
    } else {
      targetPosition.top = anchorOrigin.vertical === 'center' ? anchor.center : (anchorOrigin.vertical === selfOrigin.vertical ? anchor.top : anchor.bottom)
      targetPosition.maxHeight = Math.min(target.bottom, innerHeight - targetPosition.top)
    }
  }

  if (targetPosition.left < 0 || targetPosition.left + target.right > innerWidth) {
    targetPosition.maxWidth = Math.min(target.right, innerWidth)
    if (selfOrigin.horizontal === 'middle') {
      targetPosition.left = anchor[selfOrigin.horizontal] > innerWidth / 2 ? innerWidth - target.right : 0
    } else if (cover) {
      targetPosition.left = targetPosition.left < 0 ? 0 : innerWidth - target.right
    } else if (anchor[selfOrigin.horizontal] > innerWidth / 2) {
      const anchorY = Math.min(innerWidth, anchorOrigin.horizontal === 'middle' ? anchor.center : (anchorOrigin.horizontal === selfOrigin.horizontal ? anchor.right : anchor.left))
      targetPosition.maxWidth = Math.min(target.right, anchorY)
      targetPosition.left = Math.max(0, anchorY - targetPosition.maxWidth)
    } else {
      targetPosition.left = anchorOrigin.horizontal === 'middle' ? anchor.center : (anchorOrigin.horizontal === selfOrigin.horizontal ? anchor.left : anchor.right)
      targetPosition.maxWidth = Math.min(target.right, innerWidth - targetPosition.left)
    }
  }

  return targetPosition
}

export function getAnchorPosition (el, offset) {
  let {top, left, right, bottom} = el.getBoundingClientRect()
  const a = {
    top,
    left,
    width: el.offsetWidth,
    height: el.offsetHeight
  }

  if (offset) {
    a.top -= offset[1]
    a.left -= offset[0]
    if (bottom) {
      bottom += offset[1]
    }
    if (right) {
      right += offset[0]
    }
    a.width += offset[0]
    a.height += offset[1]
  }

  a.right = right || a.left + a.width
  a.bottom = bottom || a.top + a.height
  a.middle = a.left + ((a.right - a.left) / 2)
  a.center = a.top + ((a.bottom - a.top) / 2)

  return a
}

export function css (element, css) {
  const style = element.style

  Object.keys(css).forEach(prop => {
    style[prop] = css[prop]
  })
}

// TAMS
let setTimeoutConst = null

export function getPosition (e) {
  try {
    let posx = 0, posy = 0

    if (e.pageX || e.pageY) {
      posx = e.pageX
      posy = e.pageY
    } else if (e.clientX || e.clientY) {
      posx = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft
      posy = e.clientY + document.body.scrollTop + document.documentElement.scrollTop
    }

    return {
      x: posx,
      y: posy
    }
  } catch (e) {
    // ignore
  }
}
export function renderTooltip ($el, item, delay = 500, mouseout = false) {
  try {
    destroyTooltip()

    // 임시, 텍스트 형태만 허용
    if (!['string', 'number'].includes(typeof item)) return
    const $toolTipContainer = $('<div>').addClass('tams-global-tooltip q-tooltip animate-popup bs bs-q-tooltip bs-q-tooltip-default hidden')
    $toolTipContainer.css('text-overflow', 'ellipsis')

    setTimeoutConst = setTimeout(() => {
      $el.find('.q-tooltip').remove()

      $toolTipContainer.append(_createToolTip(item))

      $('body').append($toolTipContainer)
      if (!$toolTipContainer[0].parentNode) destroyTooltip()
      if (!document.body.contains($el[0])) destroyTooltip()

      $toolTipContainer.removeClass('hidden')
      // 마우스 오버 노드의 중단 위치에서 위로(animate-popup) 출력
      setToolTipPosition({
        el: $toolTipContainer[0],
        animate: true,
        offset: [10, 10],
        // anchorEl: $toolTipContainer[0].parentNode,
        anchorEl: $el[0],
        anchorOrigin: parsePosition(`top middle`),
        selfOrigin: parsePosition(`bottom middle`)
      })
      $toolTipContainer.addClass('hidden')
      $toolTipContainer.removeClass('hidden')

      if (mouseout) $el.hover(void 0, () => { destroyTooltip() })
    }, delay)
  } catch (e) { // ignore
    destroyTooltip()
  }
}

export function destroyTooltip () {
  try {
    const $target = $('body').find('.tams-global-tooltip')
    if ($target) {
      $target.remove()
    }
  } catch (e) {
    // ignore
  }

  clearTimeout(setTimeoutConst)
  setTimeoutConst = null
}

function _createToolTip (res) {
  const toolTipWrapper = $('<div>')
  let len = 0, data = void 0

  if (_.isArray(res)) {
    len = res.length
  } else if (_.isPlainObject(res)) {
    len = Object.keys(res).length
  }
  if (!(_.isArray(res) || _.isPlainObject(res))) {
    toolTipWrapper.append(_setTooltipStyle(res))
    return toolTipWrapper
  }
  for (var j = 0; j < len; j++) {
    if (_.isArray(res)) {
      len = res.length
      data = res[j]
    } else {
      if (_.isPlainObject(res)) {
        len = Object.keys(res).length
        data = res[Object.keys(res)[j]]
      }
    }

    toolTipWrapper.append(_setTooltipStyle(data))

    if (j !== len - 1) {
      toolTipWrapper.append($('<br/>'))
    }
  }

  return toolTipWrapper
}

function _setTooltipStyle (tooltipText) {
  let newTooltipEl
  try {
    const splitText = tooltipText.split(/\r?\n/)
    newTooltipEl = $('<div>')
    splitText.forEach((text) => {
      newTooltipEl.append($(`<div>`).text(text))
    })
  } catch (e) {
    newTooltipEl = $('<span>').text(tooltipText)
  }

  return newTooltipEl
}
